<template>
    <div id="app" :class="this.$store.state.nightMode ? 'dark' : ''">
        <div class="main-overlay" id="main-overlay" ref="main-overlay"></div>
        <header style="padding: 0 10px">
            <div style="display: flex;justify-content: center;width: 100%;align-items: center;">
                <div style="display: flex;align-items: center;">
                    <router-link :to="{name: 'home'}" :params="{ locationCity: this.$route.params.locationCity }" v-if="!this.$store.state.nightMode">
                        <img src="@/assets/logo_site.webp" class="logo-image" style="width: 250px;">
                        <img src="@/assets/logo_site_mob.webp" class="logo-image-mobile" style="width: 61px;">
                    </router-link>

                    <router-link :to="{name: 'home'}" :params="{ locationCity: this.$route.params.locationCity }" v-if="this.$store.state.nightMode">
                        <img src="@/assets/logo_site_white.webp" class="logo-image" style="width: 250px;">
                        <img src="@/assets/logo_symbol_white.webp" class="logo-image-mobile" style="width: 61px;">
                    </router-link>


                    <div class="cart-section-mobile" style="position: relative">
                        <router-link :to="{name: 'cart'}" :params="{ locationCity: this.$route.params.locationCity }" >
                            <!-- <img src="@/assets/shopping-cart.svg" style="width: 34px;"> -->
                            <inline-svg src="/img/icons/shopping-cart.svg" width="34" height="34"
                                        :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                        </router-link>
                    </div>
                </div>
            </div>
        </header>

        <div class="main-container" id="main-container" style="min-height: 100vh; padding-left: 10px; padding-right: 10px; display: flex; flex-direction: column;">
            <div style="padding: 14px; position:relative;" id="main-content">
                <div style="margin-bottom: 20px">
                    <div class="location-city__title">
                        Обирайте ваше місто і<br> замовляйте найсмачнішу піцу :)
                    </div>
                    <ul class="location-city__list">
                        <li v-for="locationCity in this.locationCities" :key="locationCity.id" class="location-city__item" @click="changeLocationCity(locationCity.id)">
                            {{ locationCity.name }}
                        </li>
                    </ul>
                </div>
            </div>

            <footer class="footer" style="justify-content: center; background: transparent">
                <div >
                    <a href="https://apps.apple.com/cy/app/black-pizza/id1498371417" target="_blank" rel="nofollow"
                       aria-label="App Store" style="display: inline-block; margin: 4px 0 4px 4px"
                       onclick="dataLayer.push({'event': 'clickAppStore'});">
                        <img src="@/assets/appstore.webp" style="width: 120px; height: 38px" alt="App Store" title="App Store">
                    </a>

                    <a href="https://play.google.com/store/apps/details?id=com.oakmont.blackpizza" target="_blank"
                       rel="nofollow" aria-label="Google Play" style="display: inline-block; margin: 4px 0 4px 4px"
                       onclick="dataLayer.push({'event': 'clickGooglePlay'});">
                        <img src="@/assets/googleplay.webp" style="width: 120px; height: 38px" alt="Google Play" title="Google Play">
                    </a>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    components: {},
    data() {
        return {
            locationCities: []
        }
    },

    methods: {
        routerToRoute(name) {
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity}});
        },

        changeMode() {
            let currentMode = JSON.parse(localStorage.getItem('nightmode')) || 0;
            let newMode = currentMode ? 0 : 1;
            localStorage.setItem('nightmode', newMode);
            this.$store.commit('setMode', newMode);

            if (newMode) {
                document.querySelector('body').style.backgroundColor = '#1c1a1a';
            } else {
                document.querySelector('body').style.backgroundColor = '';
            }
        },

        changeLocationCity(locationCityId) {
            localStorage.setItem('locationCityId', locationCityId);
            this.$store.commit('setLocationCityId', locationCityId);

            if(locationCityId == 1) {
                this.openCity('/lutsk');
            }
            else if(locationCityId == 2) {
                this.openCity('/kyiv');
            }
        },

        // Сторінка міста з повним перезавантаженням. У демо-збірці (адреси #/…) replace міняє лише хеш, тому ще й reload
        openCity(path) {
            window.location.replace(this.$router.resolve(path).href);
            if (this.$router.mode === 'hash') window.location.reload();
        }
    },

    beforeMount() {
        this.$store.dispatch('getLocationCities').then(locationCities => {
            this.locationCities = locationCities;

            if(this.locationCities && this.locationCities.length == 1) {
                this.changeLocationCity(this.locationCities[0].id);
            }
        });
    },

    mounted() {
        localStorage.setItem('cart', JSON.stringify([]));
    },
}
</script>